import { belongsTo, hasMany } from 'miragejs';
import Geometry from './geometry';

export default Geometry.extend({
  coordinates: hasMany('graphql/coordinate'),
  center: belongsTo('graphql/center'),
});
